import { notify } from "../../App/components/Notify";
export const getLogicFunctionFromString = (fnStr) => {
    if (!fnStr) return () => true;
    try {
        return new Function(fnStr)();
    } catch (err) {
        return () => true;
    }
}

export const aclAllowApi = (cb, aclData, method, showNotification = false) => {
    switch (method) {
        case 'GET': {
            if (!aclData?.get && showNotification) notify.error({ message: "Unauthorized to perform this action!" });
            else if (aclData?.get) return cb();
            break;
        }
        case 'POST': {
            if (!aclData?.post && showNotification) notify.error({ message: "Unauthorized to perform this action!" });
            else if (aclData?.post) return cb();
            break;
        }
        case 'PUT': {
            if (!aclData?.put && showNotification) notify.error({ message: "Unauthorized to perform this action!" });
            else if (aclData?.put) return cb();
            break
        }
        case 'DELETE': {
            if (!aclData?.delete && showNotification) notify.error({ message: "Unauthorized to perform this action!" });
            else if (aclData?.delete) return cb();
            break;
        }
        default: {
            if (showNotification) notify.error({ message: "Unauthorized to perform this action!" });
            return null;
        }
    }
}